export const DATE_FORMAT = 'MMM DD, YYYY';
export const TIME_FORMAT = 'h:mm a';
export const TIME_DATE_FORMAT = 'h:mm a, MMM DD, YYYY';
export const DATE_TIME_FORMAT = 'YYYY-MM-DD HH:mm:ss';
export const DATE_BEFORE_TIME_FORMAT = 'MMM DD, YYYY, h:mm a';
export const YEAR_MONTH_DATE_FORMAT = 'YYYY-MM-DD';
export const DAY_MONTH_YEAR_FORMAT = 'DD MMM YYYY';